import * as Actions from '../../actions';

const initialState = { data: null };

const receivedFilesReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_RECEIVED_FILES_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default receivedFilesReducer;
